import React from 'react';
import { RouterProvider, createBrowserRouter, createHashRouter } from 'react-router-dom';

import './App.css';
import Movies from './components/Movies/Movies';
import People from './components/People/People';
import TvShow from './components/TvShow/TvShow';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';

import Details from './components/Detailes/Details';
import PersonDetailes from './components/Detailes/PersonDetailes';


let routers = createHashRouter([
  {
    path: '/', element: < Layout />, children: [
      { path: '/', element: < Home /> },
      { path: 'movies', element: <Movies /> },
      { path: 'tv', element: < TvShow /> },
      { path: 'people', element: <People /> },
      { path: 'movies', element: <Movies /> },
   
      { path: 'details', element: < Details /> },
      { path: 'personDetailes', element: < PersonDetailes /> },
      { path: '*', element: < Home /> },





    ]
  }
])

function App() {
  return (<>
    < RouterProvider router={routers} />
  </>
  );
}

export default App;
